(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-dropdown-menu"] && !Shopify.designMode) return;
  try {
    function initializeToxtoxMenus() {
    document.querySelectorAll('.header__inline-menu details').forEach((details) => {
      const summary = details.querySelector('summary');
      const link = summary?.querySelector('a');
      if (!link || details.dataset.toxtoxMenuReady) return;
      details.dataset.toxtoxMenuReady = 'true';
      details.addEventListener('mouseenter', () => {
        if (window.matchMedia('(hover: hover)').matches) details.open = true;
      });
      details.addEventListener('mouseleave', () => {
        if (window.matchMedia('(hover: hover)').matches) details.open = false;
      });
      link.addEventListener('click', (event) => event.stopPropagation());
    });
  }
  initializeToxtoxMenus();
  document.addEventListener('shopify:section:load', initializeToxtoxMenus);
  } catch(e) { console.error(e); }
})();

})();
